import axios, { AxiosRequestConfig } from 'axios';

const envBaseUrl = import.meta.env.REACT_APP_API_URL;
export const baseUrl = envBaseUrl || `https://api.${window.location.host}`;
const baseApiUrl = `${baseUrl}/api/v1`;
const monolithBaseUrl = import.meta.env.REACT_APP_UNBH_API_URL;

export const axiosInstance = axios.create({
  baseURL: baseApiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiGet = async <T>(url: string, queryParams?: any, config?: AxiosRequestConfig) => {
  const params = queryParams !== undefined ? queryParams : {};
  return await axiosInstance.get<T>(url, { params, ...config });
};

export const apiMonolithGet = async <T>(
  url: string,
  queryParams?: any,
  config?: AxiosRequestConfig,
) => {
  const params = queryParams !== undefined ? queryParams : {};
  return await axiosInstance.get<T>(url, { baseURL: monolithBaseUrl, params, ...config });
};

export const apiPost = async <T>(url: string, data?: any, config?: AxiosRequestConfig) => {
  return await axiosInstance.post<T>(url, data, config);
};

export const apiPut = async <T>(url: string, data?: any, config?: AxiosRequestConfig) => {
  return await axiosInstance.put<T>(url, data, config);
};

export const apiPatch = async <T>(url: string, data?: any, config?: AxiosRequestConfig) => {
  return await axiosInstance.patch<T>(url, data, config);
};

export const apiDelete = async <T>(url: string, config?: AxiosRequestConfig) => {
  return await axiosInstance.delete<T>(url, config);
};
